<template>
  <div>
    <router-link :to="resolveRoute">
      <div class="card-container uk-width-1-1" uk-grid>
      <span :class="{'declined': declined, 'pending':pending, 'shared': shared}" class="icon"
            v-if="displayIcon"></span>
        <div class="uk-width-1-5 image-left-padding">
          <div class="card-content-image">
            <img :src="item.previewUrl" @error="onError" />
          </div>
        </div>
        <div class="uk-width-3-5 left-padding">
          <div class="uk-text-truncate ">
            <span class="card-content-title" v-if="!authorMouseOver">{{item.title}}</span>
            <span class="card-content-title-hover" v-else>{{item.title}}</span>
          </div>
          <div class="top-padding" v-if="!isAuthorEmptyOrNil(item.author)">
            <router-link :to="{name: 'Search', query:{searchText: searchTerm, key: new Date().getTime(), author:item.author}}">
          <span class="author-style">{{$t('general.sharedBy')}}:&nbsp;<span @mouseleave="setAuthorMouseOver(false)"
                                                           @mouseover="setAuthorMouseOver(true)"
                                                           class="card-content-author">{{item.author}}</span></span>
            </router-link>
          </div>
          <div class="top-padding card-content-description">
            <p v-clampy="4">{{item.description}}</p>
          </div>
        </div>
        <div class="uk-width-1-5 left-padding" ref="contentRef">
          <div class="card-content-type uk-display-inline-block" v-for="type in types">
            <img :src="resolveIcon(type)"/>
          </div>
          <div class="card-content top-details-padding">
            <p v-clampy="2">
              <span v-if="defaultLanguage" class="uk-text-bold">{{$t('general.grades')}}:</span>
              <span v-else class="uk-text-bold">{{$t('general.ages')}}:</span>
              <span v-if="defaultLanguage">{{resolveGradesString}}</span>
              <span v-else>{{resolveAgesString}}</span>
            </p>
          </div>
          <div class="card-content details-padding">
            <p v-clampy="3">
              <span class="uk-text-bold">{{$t('general.subjects')}}:</span>
              <span>{{resolveSubjectsString}}</span>
            </p>
          </div>
          <div v-if="standardSetExists" class="card-content details-padding">
            <p v-clampy="3">
              <span class="uk-text-bold">{{$t('general.standard')}}:</span>
              <span>{{resolveStandardsString}}</span>
            </p>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
  import Router from '../../../../router/index'
  import iconUtil from '../../../../utils/icon-util'
  import gradeUtil from '../../../../utils/grade-util'
  import ageUtil from '../../../../utils/age-util'
  import rangeBuilder from '../../../../utils/range-builder-util'
  import * as routes from '../../../../enums/routes'
  import * as moderationStatus from '../../../../enums/moderation-status'
  import dateUtil from '../../../../utils/date-util'
  import {mapGetters} from 'vuex'
  import subject from '../../../../utils/subject-translator-util'

  const ICON_SIZE_WITH_PADDING = 45
  const ELLIPSIS_ICON = 'ELLIPSIS'

  export default {
    name: 'contentListItem',
    props: ['item', 'lastPulledDate'],
    data() {
      return {
        types: [],
        authorMouseOver: false,
        pending: false,
        shared: false,
        declined: false,
        ManageResourcesPage: this.$route.name === routes.MANAGE_RESOURCES_NAME || this.$route.name === routes.PENDING_RESOURCES_NAME,
        ModerateResourcesPage: this.$route.name === routes.ROUTE_NAME_MODERATE_RESOURCES || this.$route.name === routes.ROUTE_NAME_MODERATE_RESOURCES_STATUS,
        defaultLanguage: this.$i18n.locale === 'en' || this.$i18n.locale === 'en-US'
      }
    },
    methods: {
      setAuthorMouseOver(val) {
        this.authorMouseOver = val
      },
      onError(e) {
        e.target.src = iconUtil.resolve('IMG ERROR')
      },
      preview(contentId) {
        if (this.ManageResourcesPage) {
          Router.push({
            name: routes.ROUTE_NAME_MYRESOURCE,
            params: {id: contentId}
          })
        } else if (this.ModerateResourcesPage) {
          Router.push({
            name: routes.ROUTE_NAME_MODERATE_RESOURCE,
            params: {id: contentId}
          })
        } else {
          Router.push({path: 'preview/' + contentId})
        }
      },
      resolveIcon(type) {
        return iconUtil.resolve(type)
      },
      resolveGrade(grade) {
        return gradeUtil.resolve(grade)
      },
      renderTypes() {
        try {
          let width = this.$refs.contentRef.offsetWidth
          let iconsToShow = Math.floor(width / ICON_SIZE_WITH_PADDING)
          this.types = this.item.componentTypes
          if (iconsToShow <= 4) {
            if (this.types) {
              if (this.types.length > iconsToShow) {
                this.types = this.types.slice(0, iconsToShow - 1)
                this.types.push(ELLIPSIS_ICON)
              }
            }
          } else {
            if (this.types.length === 5) { // ux require only 3 icons & the ellipsis to display if there are types
              this.types = this.types.slice(0, 3)
              this.types.push(ELLIPSIS_ICON)
            }
          }
        } catch (err) {
          this.types = []
        }
      },
      isAuthorEmptyOrNil(author) {
        if (author === '<nil>' || author === null || author === undefined) {
          return true
        }
      },
      resolveStatus() {
        switch (this.item.status) {
          case moderationStatus.APPROVED.toUpperCase():
            this.shared = true
            break
          case moderationStatus.PENDING.toUpperCase():
            this.pending = true
            break
          case moderationStatus.DECLINED.toUpperCase():
            this.declined = true
            break
        }
      },
      resolveAge(level, range) {
        if (range) {
          return ageUtil.resolve(level, range)
        } else {
          return ageUtil.resolve(level)
        }
      },
      resolveSubject(id) {
        return subject.resolveToMasterSubjectList(id, this.$t('subjects'))
      }
    },
    computed: {
      ...mapGetters(['searchTerm', 'getStandards']),
      resolveRoute() {
        const id = this.item.shareId || this.item.contentId
        if (this.ManageResourcesPage) {
          return {
            name: routes.ROUTE_NAME_MYRESOURCE,
            params: {id: id}
          }
        } else if (this.ModerateResourcesPage) {
          return {
            name: routes.ROUTE_NAME_MODERATE_RESOURCE,
            params: {id: id}
          }
        } else {
          return {path: 'preview/' + id}
        }
      },
      resolveGradesString() {
        let gradeString = ''
        for (let i = 0; i < this.ranges.length; i++) {
          if (this.ranges[i].high !== undefined) {
            gradeString += this.resolveGrade(this.ranges[i].low) + ' to ' + this.resolveGrade(this.ranges[i].high)
            if ((i + 1) < this.ranges.length) {
              gradeString += '; '
            }
          } else {
            gradeString += this.resolveGrade(this.ranges[i].low)
          }
        }
        return gradeString
      },
      resolveAgesString() {
        let ageString = ''
        for (let i = 0; i < this.ranges.length; i++) {
          if (this.ranges[i].high !== undefined) {
            ageString += this.resolveAge(this.ranges[i].low) + ' - ' + this.resolveAge((this.ranges[i].high < 13) ? this.ranges[i].high + 1 : this.ranges[i].high)
            if ((i + 1) < this.ranges.length) {
              ageString += '; '
            }
          } else {
            ageString += this.resolveAge(this.ranges[i].low, true)
          }
        }
        return ageString
      },
      resolveSubjectsString() {
        let subjectsString = ''
        let subjects = []
        if (this.item.subjects) {
          for (let i = 0; i < this.item.subjects.length; i++) {
            if (this.resolveSubject(this.item.subjects[i]) !== undefined) {
              subjects.push(this.resolveSubject(this.item.subjects[i]))
            }
          }
          subjects = [...new Set(subjects)]
          for (let i = 0; i < subjects.length; i++) {
            subjectsString += subjects[i]
            if ((i + 1) < subjects.length) {
              subjectsString += ', '
            }
          }
        }
        return subjectsString
      },
      resolveStandardsString() {
        let standards = this.getStandards
        let standardString = ''
        standardString = standards.find(item => item.id === this.item.standardSets[0]).title
        return standardString
      },
      ranges() {
        let gradeRanges = []
        try {
          for (let grade of this.item.grades) {
            let range = rangeBuilder.buildRanges(grade.levels)
            for (let rng of range) {
              gradeRanges.push(rng)
            }
          }
        } catch (err) {
          gradeRanges.push({'low': 1})
        }
        return gradeRanges
      },
      displayIcon() {
        return dateUtil.compareTime(this.lastPulledDate, this.item.lastModTime)
      },
      standardSetExists() {
        if (this.item.standardSets) {
          if (this.item.standardSets.length !== 0) {
            return true
          }
          return false
        }
        return false
      }
    },
    mounted() {
      this.renderTypes()
      this.resolveStatus()
      window.addEventListener('resize', this.renderTypes)
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../../styles/breakpoints';
  @import '../../../../styles/colours';

  .icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    box-sizing: border-box;
    border-radius: 100%;
    margin-right: -8px;
    margin-top: -6px;
  }

  .pending {
    background-color: $warning-orange;
  }

  .declined {
    background-color: $input-warning;
  }

  .shared {
    background-color: $approved-indicator;
  }

  .uk-grid > .uk-grid-margin {
    margin-top: 0;
  }

  .card-container {
    position: relative;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    padding: 15px;
    margin-bottom: 10px;
    max-height: 188px;

    &:hover {
      background-color: #ffffff;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.3);
      cursor: pointer;

      .card-content-title {
        text-decoration: underline;
      }
    }
  }

  .top-padding {
    padding-top: 10px;
  }

  .top-details-padding{
    padding-top: 5px;
  }

  .details-padding{
    padding-top: 0;
  }

  .left-padding {
    padding-left: 10px;
  }

  .card-content-title {
    font-size: 16px;
    font-weight: bold;
    color: $content-link-blue;
  }

  .card-content-title-hover {
    font-size: 16px;
    font-weight: bold;
    color: $content-link-blue;
    text-decoration: none;
  }

  .card-content-author {
    font-size: 12px;
    color: $content-link-blue;

    &:hover {
      text-decoration: underline;
    }
  }

  .card-content-image {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    max-width: 190px;
    max-height: 142px;
    overflow: hidden;
  }

  .card-content-description {
    word-break: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    font-size: 14px;
    padding-top: 10px;
    color: $content-text;
  }

  .card-content-type {
    padding-right: 10px;
  }

  .image-left-padding {
    padding-left: 15px;
  }

  .card-content {
    font-size: 12px;
    color: $content-text;
  }

  .uk-first-column {
    padding-left: 0;
  }

  .uk-first-column.image-left-padding {
    padding-left: 15px;
  }

  .uk-grid {
    margin-left: 0;
    padding-left: 0;
  }

  .author-style {
    font-size: 12px;
    color: $content-text;
  }

  a {
    &:hover {
      text-decoration: none;
      font-weight: normal;
    }
  }

  @media screen and (min-width: $breakpoint-medium) {
    .card-content-title {
      font-size: 18px;
    }
    .card-content-title-hover {
      font-size: 18px;
    }
  }

  @media screen and (min-width: $breakpoint-xlarge) {
    .card-content {
      font-size: 14px;
    }
    .card-content-author {
      font-size: 14px;
    }
    .card-content-description {
      font-size: 16px;
    }
  }
</style>
